/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ApplicationComponent } from './application.page';
import { KeywordComponent } from './keyword.page'
export const routes: Routes = [
    { path: 'application', component: ApplicationComponent },
    { path: 'application/:id1/:id2/:id3', component: KeywordComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [ApplicationComponent, KeywordComponent]
})
export class ApplicationModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/application/application.module.ts